'use client';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import mediaQuery from 'css-mediaquery';
import { FC, ReactNode } from 'react';

const getTheme = (deviceType: string = '') =>
  createTheme({
    components: {
      MuiUseMediaQuery: {
        defaultProps: {
          ssrMatchMedia: (query: string) => {
            return {
              matches: mediaQuery.match(query, {
                // The estimated CSS width of the browser.
                width:
                  { mobile: '0px', tablet: '768px', smallDesktop: '1024px' }[
                    deviceType
                  ] || '1280px',
              }),
            };
          },
        },
      },
    },
  });

export const ThemeContext: FC<{ children: ReactNode; deviceType?: string }> = ({
  children,
  deviceType,
}) => {
  return <ThemeProvider theme={getTheme(deviceType)}>{children}</ThemeProvider>;
};
